import React from 'react';

import axios from 'axios';
import { API_URL, DEFAULT_PATHS } from 'config.js';
import { store } from 'store.js';
import { caricamento, aggiornaContratti, aggiornaContrattiSupp, caricamentoContrattiSupp, selezionaContratto } from 'features/80/contratti/contrattiSlice';

import { Button } from 'react-bootstrap';

import { USER_ROLE } from 'constants.js';

const API_CONTRATTI_URL = `${API_URL}/80/contratti/`;
const API_CONTRATTI_SUPP_URL = `${API_URL}/80/contratti_supp/`;
const API_MODIFICA_URL = `${API_URL}/80/set_dato/`;

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const mesi = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function getColonne(history) {
  const {
    auth: {
      currentUser: { tipoUtenza },
    },
  } = store.getState();

  const colonne80 = [
    {
      dataField: 'Contract',
      text: 'Contract',
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Type',
      text: 'Type',
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Booking',
      text: 'Booking',
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Contract_x0020_Date',
      text: 'Contract date',
      formatter: (cell, row) => cell?.split('-')?.reverse('-')?.join('/'),
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },

    {
      dataField: 'Month',
      text: 'Ship unloading month',
      formatter: (cell, _) => mesi[cell - 1],
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Year',
      text: 'Year',
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },

    {
      dataField: 'Qty',
      text: 'Qty',
      formatter: (cell, row) =>
        `${row?.Measure?.toLowerCase() === 'lbr' ? 'lb' : 'Kg'} ${cell
          ?.toFixed(2)
          .toString()
          .split(/(?=(?:\d{3})+(?:\.|$))/g)
          .join(',')}`,
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },

    {
      dataField: 'ID',
      text: 'Details',
      formatter: (cell, row) => {
        return (
          <Button
            onClick={() => {
              store.dispatch(selezionaContratto({ idContratto: cell, codiceContratto: row.Contract }));
              history.push(`${appRoot}/80/dettagliContratto/${cell}/${encodeURIComponent(row.Contract)}`);
            }}
          >
            Details
          </Button>
        );
      },
    },
  ];

  const colonne60 = [
    {
      dataField: 'ID',
      text: 'Dettagli',
      formatter: (cell, row) => {
        return (
          <Button
            onClick={() => {
              store.dispatch(selezionaContratto({ idContratto: cell, codiceContratto: row.Contratto }));
              history.push(`${appRoot}/80/dettagliContratto/${cell}/${encodeURIComponent(row.Contratto)}`);
            }}
          >
            Details
          </Button>
        );
      },
    },
    {
      dataField: 'Contratto',
      text: 'Contratto',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Data',
      text: 'Data',
      formatter: (cell, _) => cell?.split('-')?.reverse()?.join('/'),
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Container',
      text: 'Container',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Qualità',
      text: 'Qualità',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'NumeroBookingConfirmation',
      text: 'NumeroBookingConfirmation',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'CompagniaDiNavigazione',
      text: 'CompagniaDiNavigazione',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'NomeNave',
      text: 'NomeNave',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'DataPrevistoArrivo',
      text: 'DataPrevistoArrivo',
      formatter: (cell, _) => cell?.split('-')?.reverse()?.join('/'),
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'DataArrivoUfficiale',
      text: 'DataArrivoUfficiale',
      formatter: (cell, _) => cell?.split('-')?.reverse()?.join('/'),
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'AllegatoArrivoDocumentiEmail',
      text: 'AllegatoArrivoDocumentiEmail',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'DataOraArrivoDocumentiOriginali',
      text: 'DataOraArrivoDocumentiOriginali',
      formatter: (cell, _) => cell?.split('-')?.reverse()?.join('/'),
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'ExtraCosti',
      text: 'ExtraCosti',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'Fornitore',
      text: 'Fornitore',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
    {
      dataField: 'NoteSpedizioni',
      text: 'NoteSpedizioni',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },

    {
      dataField: 'TipoMerce',
      text: 'TipoMerce',
      headerStyle: { width: '30px' },
      sort: true,
      sortCaret: (order, c) => {
        switch (order) {
          case 'asc':
            return ' ᗑ';
          case 'desc':
            return ' ᗐ';
          default:
            return null;
        }
      },
    },
  ];

  return tipoUtenza === USER_ROLE.Fornitore ? colonne80 : colonne60;
}

const getCredentials = () => {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  return [utente, pin];
};

export const richiediDati = async () => {
  store.dispatch(caricamento(true));

  const [utente, pin] = getCredentials();

  const res = await axios.post(API_CONTRATTI_URL, { utente, pin });
  const {
    data: {
      successo,
      errore,
      dati: { contratti },
    },
  } = res;
  if (!successo) {
    store.dispatch(caricamento(false));
    return alert(errore);
  }

  if (successo && contratti.length) {
    store.dispatch(aggiornaContratti(contratti));
    store.dispatch(caricamento(false));
  }

  store.dispatch(caricamento(false));
  return true;
};

export const getContrattiSupp = async () => {
  store.dispatch(caricamentoContrattiSupp(true));

  const [utente, pin] = getCredentials();

  const {
    contratti80: { idContratto },
  } = store.getState();

  const res = await axios.post(API_CONTRATTI_SUPP_URL, { utente, pin, idContratto });

  const {
    successo,
    errore,
    dati: { campi },
  } = res.data;

  if (!successo) {
    store.dispatch(caricamentoContrattiSupp(false));
    return alert(errore);
  }

  if (successo) {
    store.dispatch(aggiornaContrattiSupp(campi));
  }

  store.dispatch(caricamentoContrattiSupp(false));
  return true;
};

export const updateDato = async (idDato, val, file = 'dato') => {
  store.dispatch(caricamentoContrattiSupp(true));

  const [utente, pin] = getCredentials();
  const {
    contratti80: { idContratto },
  } = store.getState();

  const valore = file === 'file' ? val.slice(28) : val;

  const res = await axios.post(API_MODIFICA_URL, { utente, pin, idContratto, idDato, valore, tipofile: file, tipo: 'contratto' });

  const { successo, errore } = res.data;

  if (!successo) {
    store.dispatch(caricamentoContrattiSupp(false));
    return alert(errore);
  }

  return getContrattiSupp();
};
